import cx from 'classnames';
import { v4 as uuid } from 'uuid';
import { CatSkeleton } from '@blocks-react/components/Skeleton';
import { PAGE_BREAKPOINTS } from '../../../constants/commonConstants';
import { useBreakpoint } from '../../../hooks';
import { ProductCardLoaderProps } from '../types';
import styles from './product-card-loader.module.scss';

export const ProductCardLoader = ({
  loaderCount = 4,
  rowCount = 2,
  classname = 'pb-3 me-3'
}: ProductCardLoaderProps) => {
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);

  return (
    <div className={styles['bestseller-loader__overflow']}>
      {[...Array(rowCount)].map(() => {
        return (
          <div className={isMD ? 'd-flex ' : 'w-100'} key={uuid()}>
            {[...Array(loaderCount)].map(() => {
              return (
                <div
                  key={uuid()}
                  className={cx(
                    styles['bestseller-loader__container'],
                    !isMD ? 'w-100' : 'w-25',
                    classname
                  )}
                >
                  {isMD && <CatSkeleton size="sm" />}
                  <CatSkeleton size={isMD ? 'lg' : undefined} />
                  <CatSkeleton size="xl" />
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default ProductCardLoader;
